/**
 * Partner Forms — Modal trigger for Active Campaign forms
 * Maps partnership card headings to AC form IDs and opens modals on "Apply Now" click.
 */
(function () {
  var formMap = window.__partnerFormMap || {};

  function openModal(formId) {
    var modal = document.getElementById('partner-modal-' + formId);
    if (!modal) return;
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('partner-modal-open');

    // Focus the first input inside the form after a short delay
    setTimeout(function () {
      var firstInput = modal.querySelector('input[type="text"], select, textarea');
      if (firstInput) firstInput.focus();
    }, 300);
  }

  function closeModal(modal) {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('partner-modal-open');
  }

  function init() {
    // Attach open triggers to multi-column card buttons
    var cards = document.querySelectorAll('.cc-multi-column .card');
    cards.forEach(function (card) {
      var heading = card.querySelector('.card__title');
      if (!heading) return;

      var headingText = heading.textContent.trim().toLowerCase();
      var formId = formMap[headingText];
      if (!formId) return;

      var button = card.querySelector('.card__button');
      if (!button) return;

      button.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        openModal(formId);
      });
    });

    // Attach close triggers to all modals
    var modals = document.querySelectorAll('.partner-modal');
    modals.forEach(function (modal) {
      var closeBtn = modal.querySelector('.partner-modal__close');
      if (closeBtn) {
        closeBtn.addEventListener('click', function () {
          closeModal(modal);
        });
      }

      var backdrop = modal.querySelector('.partner-modal__backdrop');
      if (backdrop) {
        backdrop.addEventListener('click', function () {
          closeModal(modal);
        });
      }

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && modal.classList.contains('is-open')) {
          closeModal(modal);
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
